import React from 'react';
import { Box, ButtonBase, Paper, Typography } from '@mui/material';
import Order from '@components/order/models/list/Order';
import OrderListItemIcon from './OrderListItemIcon';
import { formatDateTime } from '@utils/dateTimeFormatter';
import OrderListItemAddress from './OrderListItemAddress';
import Amount from '@components/common/molecules/Amount';
import OrderListItemAdministration from './OrderListItemAdministration';
import EnvironmentType from './EnvironmentType';

interface OrderListItemProps {
    order: Order;
    onClick: (order: Order) => void;
    isAdministration?: boolean
}

const OrderListItem: React.FC<OrderListItemProps> = ({ order, onClick, isAdministration }) => {
    return (
        <ButtonBase sx={{ width: "100%" }} onClick={() => onClick(order)}>
            <Paper sx={{ width: "100%", p: 2, position: "relative" }}>
                <Box display={"flex"} flexDirection={"row"} gap={2}>
                    <OrderListItemIcon order={order} />

                    <Box display={"flex"} flexGrow={1} flexDirection={"column"} alignItems={"flex-start"}>
                        <Typography variant='subtitle2' textAlign={"left"} fontWeight={600}>{`${formatDateTime(order.dateCreated)}`}</Typography>
                        <Typography variant='subtitle2' textAlign={"left"} fontWeight={600} mb={0.5}>{order.restaurant?.name}</Typography>
                        <OrderListItemAddress order={order} />
                        <Typography variant='subtitle2' color={"text.secondary"} textAlign={"left"}>{order.locationDescription}</Typography>

                        {isAdministration && <OrderListItemAdministration order={order} />}
                    </Box>

                    <Amount amount={order.totalAmount} fontWeight={600} alignSelf={"center"} />
                </Box>

                <EnvironmentType order={order} />
            </Paper>
        </ButtonBase>
    )
}

export default OrderListItem;